@if(isEditing){
  <app-annual-school-profiles-form
    *ngIf="isEditing"
    [isEditMode]="true"
    [profileId]="profile.id"
    (formSubmitted)="onFormUpdated($event)">
  </app-annual-school-profiles-form>
} @else {
  <div class="container main-content mt-5 pt-5 col-lg-10 col-md-10 col-12" *ngIf="profileExists;else notLoaded">
    <div class="custom-card-large">
      <div class="card-body d-flex row justify-content-center text-center">
        <div>
          <div class="d-flex justify-content-end">
            <button *ngIf="!profile.isDeleted && !isDeleting"
                    class="btn btn-primary delete-btn"
                    (click)="deleteProfile()"
                    style="padding-bottom: 3px;">
              <span class="material-symbols-outlined">
                delete
              </span>
            </button>

            <button *ngIf="profile.isDeleted && (teacher?.role?.toLowerCase() === 'admin')"
                    class="btn btn-primary delete-btn"
                    (click)="undeleteProfile()">
              Undelete
            </button>
          </div>
        </div>
        <div *ngIf="profileExists; else projectDoesntExist">
          <div *ngIf="profile; else noProject">
            <div class="d-flex justify-content-center align-items-center gap-2">
              <h3 class="custom-card-title custom-title my-2" style="margin: 0;">
                {{ profile.school | titlecase }}
              </h3>
              <span class="material-symbols-outlined custom-card-title"
                    style="font-size: 28px; vertical-align: middle;">
                      location_on
                </span>
            </div>

            <!-- School Year -->
            <div class="col-12 mb-4"><b>School Year:</b> {{profile.schoolYear}}</div>

            <!-- GHS Rep-->
            <h4 class="custom-card-title mt-3 mb-3">GHS Representatives</h4>
            <div class="row g-3 justify-content-center align-items-stretch">
              <!-- Primary Representative -->
              <div class="col-12 col-md-4">
                <app-annual-school-profiles-details-card
                  [name]="profile.ghsRepresentativeName"
                  [email]="profile.ghsRepresentativeEmail"
                  [isAdditional]="false">
                </app-annual-school-profiles-details-card>
              </div>

              <!-- GHS Additional Representatives -->
              <div *ngFor="let name of profile.additionalGhsRepresentativeName; let i = index"
                   class="col-12 col-md-4">
                <app-annual-school-profiles-details-card
                  [name]="profile.additionalGhsRepresentativeName[i]"
                  [email]="profile.additionalGhsRepresentativeEmail[i]"
                  [isAdditional]="true">
                </app-annual-school-profiles-details-card>
              </div>
            </div>
            <br/>

            <div class="row">
              <!-- Number of Students, Teachers and Staff -->
              <div class="col-6">
                <h4 class="custom-card-title mt-3 mb-3">Number of Participants</h4>
                <div class="row row-cols-1 row-cols-md-2 g-3">
                  <div class="col-6 num">
                    <div class="card border-0 h-100 small-card">
                      <div class="card-body p-3">
                        <div class="d-flex align-items-center gap-2">
                          <div class="p-2 bg-light rounded d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined text-primary fs-5">school</span>
                          </div>

                          <div>
                            <p class="text-muted small mb-1 fw-medium">Students Enrolled</p>
                            <p class="fw-bold fs-5 mb-0 text-dark">{{ profile.numOfStudents }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="card border-0" *ngIf="profile.studentServingOnGreenYouth.length > 0">
                        <div class="card-body">
                          <p class="fw-bold">Students on Green Youth: </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 num">
                    <div class="card border-0 h-100 small-card">
                      <div class="card-body p-3">
                        <div class="d-flex align-items-center gap-2">
                          <div class="p-2 bg-light rounded d-flex align-items-center justify-content-center">
                            <span class="material-symbols-outlined text-primary fs-5">group</span>
                          </div>

                          <div>
                            <p class="text-muted small mb-1 fw-medium">Teachers and Staff</p>
                            <p class="fw-bold fs-5 mb-0 text-dark">{{ profile.numOfTeacherAndStaff }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="card border-0" *ngIf="profile.studentServingOnGreenYouth.length > 0">
                        <div class="card-body">
                          <p>{{ profile.studentServingOnGreenYouth }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Environmental Education Goals -->
              <div class="col-6 d-flex flex-column">
                <h4 class="custom-card-title mt-3 mb-3">Environmental Education Goals</h4>
                <div class="card border-0 flex-grow-1">
                  <div class="card-body">
                    <div *ngFor="let goal of profile.goals" class="d-inline-block me-2 mb-2">
                      <span class="badge rounded-pill bg-primary">{{ goal }}</span>
                    </div>
                    <p style="margin: 0">{{ profile.goalsComment }}</p>
                  </div>
                </div>
              </div>
            </div>

            <br/>

            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3 flex-column flex-md-row">
                <a routerLink="/annual-school-profiles" class="btn btn-primary w-25">Return To List View</a>
                <button class="btn btn-primary w-25" (click)="toggleEditing()">Edit</button>
                <button class="btn btn-primary w-25" (click)="addProject()">Add a Project</button>
                <button *ngIf="teacherRole?.toLowerCase() === 'admin'" class="btn btn-primary w-25" (click)="duplicateProfile()">
                  Duplicate
                </button>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noProject>
          <h4>Loading Project Details...</h4>
        </ng-template>
      </div>

      <ng-template #projectDoesntExist>
        <h3 class="custom-card-title">Project does not exist.</h3>
      </ng-template>
    </div>
  </div>
}

<ng-template #notLoaded>
  <div class="container mt-5 pt-5 col-lg-10 col-me-10 col-12 text-center">
    <div class="custom-card-large">
      <h2>You do not have access to this page.</h2>
    </div>
  </div>
</ng-template>
